import React from 'react';

const ConnectionStatusIndicator = React.memo(({ sseConnectionStatus }) => {
  const getStatusInfo = () => {
    switch (sseConnectionStatus) {
      case 'connected':
        return { color: '#12B76A', text: 'Live' };
      case 'error':
        return { color: '#F59E0B', text: 'Reconnecting...' };
      case 'failed':
        return { color: '#EF4444', text: 'Offline' };
      default:
        return { color: '#6B7280', text: 'Offline' };
    }
  };

  const { color, text } = getStatusInfo();

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      fontSize: '12px',
      color: color,
      fontWeight: '500'
    }}>
      <div style={{
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        backgroundColor: color,
        opacity: sseConnectionStatus === 'error' ? 0.5 : 1,
        transition: 'opacity 0.5s ease-in-out',
        animation: sseConnectionStatus === 'error' ? 'pulse 1s infinite' : 'none'
      }} />
      {text}
    </div>
  );
});

ConnectionStatusIndicator.displayName = 'ConnectionStatusIndicator';

export default ConnectionStatusIndicator;
